import { useTranslation } from "react-i18next";
import Notice from "components/tw/notice";
import { btnLinkCls } from "components/tw/classes";
import { formatPrettyDate } from "utils/helperFunctions";

type Props = {
  /** When the stored draft was written (ISO time). */
  savedAt: string;
  onRestore: () => void;
  onDiscard: () => void;
};

/** Offers a draft found for this page: put it back, or throw it away. */
export default function DraftBanner({ savedAt, onRestore, onDiscard }: Props) {
  const { t, i18n } = useTranslation();
  const language = (i18n as unknown as { language?: string }).language || "en";

  return (
    <Notice tone="info">
      <p>{t("order_draft_found", { time: formatPrettyDate(savedAt, language, true) })}</p>
      <div className="flex gap-4">
        <button type="button" className={btnLinkCls} onClick={onRestore}>
          {t("order_draft_restore")}
        </button>
        <button type="button" className={btnLinkCls} onClick={onDiscard}>
          {t("order_draft_discard")}
        </button>
      </div>
    </Notice>
  );
}
